import { Box, Typography, styled } from "@mui/material";

export const Title = styled(Typography)({
  marginTop: "16px",
  fontWeight: "bold",
  color: "#fff",
});
export const ItemBox = styled(Box)({
  padding: "10px",
  borderRadius: "16px",
  backgroundColor: "#4caf50",
  minHeight: "140px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
});
